module.exports = __webpack_public_path__ + "static/media/onda.b32e93bc.svg";